import {IntermediatePart} from "../../intermediatePart";
import {Vanity} from "../../parts/vanity";
// import DesignNavigationItem from "../../../../visComponents/designNavigationItem";
// import uniqBy from "lodash/uniqBy";

export default class VanityCountertop extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_countertop';
    this.partName = 'Countertop';
    this.translateId = "visualizer.bathroom.vanity.vanity_countertop";
    this.homePageTitle = 'Countertops';
    this.visible = [Vanity.Types.Custom];
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new VanityCountertop())
  }

  disabledClick() {
    this.getParent().toggleVanityParts(this.disabled);
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const vanityParent = this.getParent();
    conditions.push({
      propName: "VanitySize",
      propValue: vanityParent.getCounterTopSize()
    })
    return conditions
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.getParent().activeSubType_ === Vanity.Types.Custom) {
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndexes.Vanity.CounterTop;
      }
      if(this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndexes.Vanity.CounterTop;
      }
    }
  }
}
